var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendarioBranco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3568 16.5547C10.7145 16.5547 10.1693 16.3307 9.7213 15.8827C9.2733 15.4345 9.0493 14.8893 9.0493 14.247C9.0493 13.6046 9.2733 13.0595 9.7213 12.6115C10.1693 12.1635 10.7145 11.9395 11.3568 11.9395C11.9991 11.9395 12.5444 12.1635 12.9926 12.6115C13.4406 13.0595 13.6646 13.6046 13.6646 14.247C13.6646 14.8893 13.4406 15.4345 12.9926 15.8827C12.5444 16.3307 11.9991 16.5547 11.3568 16.5547ZM1.9723 20.0547C1.46713 20.0547 1.03955 19.8797 0.689551 19.5297C0.339551 19.1797 0.164551 18.7521 0.164551 18.247V4.86245C0.164551 4.35729 0.339551 3.9297 0.689551 3.5797C1.03955 3.2297 1.46713 3.0547 1.9723 3.0547H3.3568V0.939453H4.8953V3.0547H12.4723V0.939453H13.9723V3.0547H15.3568C15.862 3.0547 16.2896 3.2297 16.6396 3.5797C16.9896 3.9297 17.1646 4.35729 17.1646 4.86245V18.247C17.1646 18.7521 16.9896 19.1797 16.6396 19.5297C16.2896 19.8797 15.862 20.0547 15.3568 20.0547H1.9723ZM1.9723 18.5547H15.3568C15.4338 18.5547 15.5043 18.5226 15.5683 18.4585C15.6325 18.3945 15.6646 18.324 15.6646 18.247V8.86245H1.66455V18.247C1.66455 18.324 1.69663 18.3945 1.7608 18.4585C1.8248 18.5226 1.8953 18.5547 1.9723 18.5547ZM1.66455 7.36245H15.6646V4.86245C15.6646 4.78545 15.6325 4.71495 15.5683 4.65095C15.5043 4.58679 15.4338 4.5547 15.3568 4.5547H1.9723C1.8953 4.5547 1.8248 4.58679 1.7608 4.65095C1.69663 4.71495 1.66455 4.78545 1.66455 4.86245V7.36245Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarioBranco);
export default __webpack_public_path__ + "static/media/CalendarioBranco.2d775772bea6d08bd14a8d0a864e94e0.svg";
export { ForwardRef as ReactComponent };